import {filterSearch, setPageNumber, setPageDisplaySize} from './internal-confidential-search.js'
import {tabKeyNavigation, tabKeyNavigationDropDownList} from "../utilities/navigation.js";
window.filterSearch = filterSearch
window.setPageNumber = setPageNumber
window.setPageDisplaySize = setPageDisplaySize

const StateProvinces = [
  {
    Id: 1,
    Code: "AL",
    Name: "Alabama"
  },
  {
    Id: 2,
    Code: "AK",
    Name: "Alaska"
  },
  {
    Id: 4,
    Code: "AZ",
    Name: "Arizona"
  },
  {
    Id: 5,
    Code: "AR",
    Name: "Arkansas"
  },
  {
    Id: 7,
    Code: "CA",
    Name: "California"
  },
  {
    Id: 8,
    Code: "CO",
    Name: "Colorado"
  },
  {
    Id: 9,
    Code: "CT",
    Name: "Connecticut"
  },
  {
    Id: 10,
    Code: "DE",
    Name: "Delaware"
  },
  {
    Id: 11,
    Code: "DC",
    Name: "District of Columbia"
  },
  {
    Id: 13,
    Code: "FL",
    Name: "Florida"
  },
  {
    Id: 15,
    Code: "GA",
    Name: "Georgia"
  },
  {
    Id: 16,
    Code: "HI",
    Name: "Hawaii"
  },
  {
    Id: 17,
    Code: "ID",
    Name: "Idaho"
  },
  {
    Id: 18,
    Code: "IL",
    Name: "Illinois"
  },
  {
    Id: 19,
    Code: "IN",
    Name: "Indiana"
  },
  {
    Id: 20,
    Code: "IA",
    Name: "Iowa"
  },
  {
    Id: 21,
    Code: "KS",
    Name: "Kansas"
  },
  {
    Id: 23,
    Code: "KY",
    Name: "Kentucky"
  },
  {
    Id: 24,
    Code: "LA",
    Name: "Louisiana"
  },
  {
    Id: 25,
    Code: "ME",
    Name: "Maine"
  },
  {
    Id: 27,
    Code: "MD",
    Name: "Maryland"
  },
  {
    Id: 28,
    Code: "MA",
    Name: "Massachusetts"
  },
  {
    Id: 29,
    Code: "MI",
    Name: "Michigan"
  },
  {
    Id: 30,
    Code: "MN",
    Name: "Minnesota"
  },
  {
    Id: 31,
    Code: "MS",
    Name: "Mississippi"
  },
  {
    Id: 32,
    Code: "MO",
    Name: "Missouri"
  },
  {
    Id: 33,
    Code: "MT",
    Name: "Montana"
  },
  {
    Id: 34,
    Code: "NE",
    Name: "Nebraska"
  },
  {
    Id: 35,
    Code: "NV",
    Name: "Nevada"
  },
  {
    Id: 37,
    Code: "NH",
    Name: "New Hampshire"
  },
  {
    Id: 38,
    Code: "NJ",
    Name: "New Jersey"
  },
  {
    Id: 39,
    Code: "NM",
    Name: "New Mexico"
  },
  {
    Id: 40,
    Code: "NY",
    Name: "New York"
  },
  {
    Id: 42,
    Code: "NC",
    Name: "North Carolina"
  },
  {
    Id: 43,
    Code: "ND",
    Name: "North Dakota"
  },
  {
    Id: 47,
    Code: "OH",
    Name: "Ohio"
  },
  {
    Id: 48,
    Code: "OK",
    Name: "Oklahoma"
  },
  {
    Id: 50,
    Code: "OR",
    Name: "Oregon"
  },
  {
    Id: 52,
    Code: "PA",
    Name: "Pennsylvania"
  },
  {
    Id: 54,
    Code: "PR",
    Name: "Puerto Rico"
  },
  {
    Id: 56,
    Code: "RI",
    Name: "Rhode Island"
  },
  {
    Id: 59,
    Code: "SC",
    Name: "South Carolina"
  },
  {
    Id: 60,
    Code: "SD",
    Name: "South Dakota"
  },
  {
    Id: 61,
    Code: "TN",
    Name: "Tennessee"
  },
  {
    Id: 62,
    Code: "TX",
    Name: "Texas"
  },
  {
    Id: 63,
    Code: "UT",
    Name: "Utah"
  },
  {
    Id: 64,
    Code: "VT",
    Name: "Vermont"
  },
  {
    Id: 65,
    Code: "VA",
    Name: "Virginia"
  },
  {
    Id: 67,
    Code: "WA",
    Name: "Washington"
  },
  {
    Id: 68,
    Code: "WV",
    Name: "West Virginia"
  },
  {
    Id: 69,
    Code: "WI",
    Name: "Wisconsin"
  },
  {
    Id: 70,
    Code: "WY",
    Name: "Wyoming"
  }
  // ,{
  //   Id: 3,
  //   Code: "AB",
  //   Name: "Alberta"
  // },
  // {
  //   Id: 6,
  //   Code: "BC",
  //   Name: "British Columbia"
  // },
  // {
  //   Id: 26,
  //   Code: "MB",
  //   Name: "Manitoba"
  // },
  // {
  //   Id: 36,
  //   Code: "NB",
  //   Name: "New Brunswick"
  // },
  // {
  //   Id: 41,
  //   Code: "NL",
  //   Name: "Newfoundland"
  // },
  // {
  //   Id: 45,
  //   Code: "NT",
  //   Name: "Northwest Territories"
  // },
  // {
  //   Id: 46,
  //   Code: "NS",
  //   Name: "Nova Scotia"
  // },
  // {
  //   Id: 49,
  //   Code: "ON",
  //   Name: "Ontario"
  // },
  // {
  //   Id: 53,
  //   Code: "PE",
  //   Name: "Prince Edward Island"
  // },
  // {
  //   Id: 55,
  //   Code: "QC",
  //   Name: "Quebec"
  // },
  // {
  //   Id: 57,
  //   Code: "SK",
  //   Name: "Saskatchewan"
  // },
  // {
  //   Id: 71,
  //   Code: "YT",
  //   Name: "Yukon"
  // }
];

const distance = [
  {
    value: "10",
    display: "10 miles"
  },
  {
    value: "25",
    display: "25 miles"
  },
  {
    value: "50",
    display: "50 miles"
  },
  {
    value: "100",
    display: "100 miles"
  }
]
const searchTableDiv = document.getElementById("searchTableDiv")

const tableFilterDiv = document.createElement("div")
tableFilterDiv.setAttribute("class", "container")
tableFilterDiv.setAttribute("id", "searchFilterContainer")

const filterNav = document.createElement("div")

filterNav.innerHTML =
  `
    <nav class="navbar navbar-expand-lg navbar-light mx-3">

      <button class="navbar-toggler w-100 justify-content-center" type="button" data-toggle="collapse" data-target="#searchFilter" aria-controls="searchFilter" aria-expanded="false" aria-label="Toggle Search">
        <span class="mt-1">Search Options</span>
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse"  id="searchFilter">
          <form  class="d-flex flex-wrap flex-row ">
              <div class="searchItem">
                  <label for="inputTitle">Job Title/Description</label>
                  <input type="text" class="form-control" id="inputTitle" style="min-width:250px;">
              </div>
              <div class="searchItem" >
                  <label for="inputId">Id</label>
                  <input type="text" class="form-control" id="inputId" style="max-width: 80px;" >
              </div>
              <div class="searchItem" >
                 <label for="inputCity">City</label>
                 <input type="text" class="form-control" id="inputCity">
              </div>
              <div class="searchItem" >
                 <label for="inputState">State</label>
                  <select id="inputState" class="form-control" style="max-width: 120px;" >
                      <option value=""></option>
                      ${StateProvinces.map((option) => (
    `<option value=${option.Code}>${option.Name}</option>`
  ))}
                  </select>
              </div>
              <div id="zipRadius" class="d-flex flex-nowrap flex-row justify-content-around searchItem">
                <div class="pr-3">
                    <label for="inputZipRadius">Zip Code</label>
                    <input type="text" class="form-control mx-auto"
                           id="inputZipRadius"
                           onchange="enableDistance()"
                            style="max-width: 60px;" >
                </div>
                <div >
                    <label for="radiusMiles" style="display: block">Distance</label>
                    <select id="radiusMiles" class="form-control" style="max-width: 90px;"  >
                      <option value="0"></option>
                       ${distance.map(distance => (
    `<option value=${distance.value}>${distance.display}</option>`
  ))}
                    </select>
                </div>
              </div>
              <div class="mx-auto">
                  <button type="submit" class="btn btn-application ml-1 mt-3" onclick={filterSearch(event)}>Search</button>
              </div>
          </form>
     </div>
      </nav>
         <div class="dataTables_length d-flex flex-nowrap flex-row justify-content-center align-items-baseline" id="pageDisplaySize">
             <label class="pr-1">Show </label>
                    <select id="jobsPerPage" onChange={setPageDisplaySize(event)}
                            class="form-control p-0" style="padding:0 !important;max-width:45px;">
                        ${[10, 15, 20].map(pageSize => (
    `<option value=${pageSize}>${pageSize}</option>`
  ))}
                    </select>
             <label class="pl-1"> Jobs per Page</label>
         </div>
`

tableFilterDiv.appendChild(filterNav)
searchTableDiv.insertBefore(tableFilterDiv, searchTableDiv.children['searchTable'])

const inputTitleFilter = document.querySelector('#inputTitle')
const inputIdFilter = document.querySelector('#inputId')
const inputCityFilter = document.querySelector('#inputCity')
const inputStateFilter = document.querySelector('#inputState')
const inputZipRadiusFilter = document.querySelector('#inputZipRadius')
const radiusMilesFilter = document.querySelector('#radiusMiles')
const jobsPerPageFilter = document.querySelector('#jobsPerPage')
// const resetBtnFilter = document.querySelector('#resetBtn')
const submitSearchFilter = document.querySelector('#submitSearch')

tabKeyNavigation(inputTitleFilter)
tabKeyNavigation(inputIdFilter)
tabKeyNavigation(inputCityFilter)
tabKeyNavigation(inputStateFilter)
tabKeyNavigation(inputZipRadiusFilter)
tabKeyNavigation(radiusMilesFilter)
tabKeyNavigation(jobsPerPageFilter)

// tabKeyNavigationDropDownList(resetBtnFilter)
tabKeyNavigationDropDownList(submitSearchFilter)
